<template>
    <div
        style="height: 100vh;width: 100%;background-color: #ffffff; background-size: cover;background-repeat: no-repeat;display: flex;align-items: center;">
        <div style="width: 250px;height: 100%;background-color: #f3f4f6;align-items: center;">
            <div style="width: 30px;height: 30px;margin-left: 20px;" v-if="winWidth < 600" @click="openDrawer">
                <img src="https://txcloud.aojuai.com/icon/aojv/aiwx_icon/gdlb.png" alt=""
                    style="width: 100%;height: 100%;">
            </div>
            <div style="margin: 10px auto; width: 90%; height: 40px;font-size: 22px;font-weight: 600;color: black;text-align: center;display: flex;align-items: center"
                v-if="winWidth > 600 && userInfo">
                <div style="width: 40px;height: 40px;border: 1px solid white;border-radius: 10px;">
                    <img :src="userInfo.auHeader" alt="" style="width: 100%;height: 100%;border-radius: 10px;">
                </div>
                <div style="color: black;font-size: 19px;margin-left: 10px;">
                    <span class="el-dropdown-link" style="font-size: 17px;font-weight: 800;">
                        {{ userInfo.auName }}
                    </span>
                </div>
                <!-- <el-dropdown @command="handleCommand" style="color: black;font-size: 19px;margin-left: 10px;">
                    <span class="el-dropdown-link" style="font-size: 17px;font-weight: 800;">
                        {{ userInfo.auName }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>
            <div style="width:100%;height:calc(100% - 70px);background-color: #F2F6FC;" v-if="winWidth > 600">
                <div class="new-chat-btn" @click="createNewChat(1)" :class="[home_btn == 1 ? 'home_btn_active' : '']">
                    <i class="el-icon-edit-outline"
                        style="font-size: 17px;margin-right: 10px;color:#409EFF;vertical-align: middle;padding-bottom: 2px;font-weight: bold;"></i>
                    <span style="font-size: 16px;font-weight: 500;">新建对话</span>
                </div>
                <div class="new-chat-btn" @click="gotoCollect(2)" :class="[home_btn == 2 ? 'home_btn_active' : '']">
                    <i class="el-icon-star-off"
                        style="font-size: 17px;margin-right: 10px;color:#409EFF;vertical-align: middle;padding-bottom: 2px;font-weight: bold;"></i>
                    <span style="font-size: 16px;font-weight: 500;">我的收藏</span>
                </div>
                <div class="new-chat-btn" @click="outLogin(3)" :class="[home_btn == 3 ? 'home_btn_active' : '']">
                    <i class="el-icon-house"
                        style="font-size: 17px;margin-right: 10px;color:#409EFF;vertical-align: middle;padding-bottom: 2px;font-weight: bold;"></i>
                    <span style="font-size: 16px;font-weight: 500;">退出登录</span>
                </div>
                <div style="height: 1px;width: 90%;margin: 15px auto;background-color: #E4E7ED;"></div>
                <div class="history_class" style="width: 100%;overflow-y: auto;height: calc(100% - 175px);">
                    <div style="margin: 20px;font-size: 14px;color: #909399;"> <i class="el-icon-time"
                            style="font-size: 15px;margin-right: 5px;color:#909399;vertical-align: middle;padding-bottom: 2px;font-weight: bold;"></i>
                        历史对话:</div>
                    <div style="width: 100%;margin: 15px auto;">
                        <template v-for="(item, index) in DiaHisList">
                            
                            <div :key="index" class="chat_history" :style="{ background: tapIndex == index ? '#e9eaec' : '#F2F6FC' }"  @click="DiaHisClick(item, index)">
                                <div
                                    style="width: 88%;margin-left: 10px;margin-top: 5px; font-size: 13px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                    {{ item.chatTitle }}</div>

                                <div
                                    style="width: 100%;display: flex;align-items: center;justify-content: space-between;">
                                    <div
                                        style=" width: 110px; padding: 0px 8px; margin: 5px; font-size: 12px;color: #909399;border: 1px solid #909399;border-radius: 30px;text-align: center;">
                                        {{ item.aaTitle || '' }}</div>
                                    <div @click="delDiaHisClick(item, indexedDB)" style="margin-right: 15px;">
                                        <i class="el-icon-delete" style="font-size: 16px;"></i>
                                    </div>

                                </div>
                                <!-- <div
                                    style="width: 100%;display: flex;align-items: center;justify-content: space-between;">
                                    <div style="margin-left: 5px;margin-top: 5px;font-size: 12px;color: #606266;">
                                        {{ item.createtime }}</div>
                                   
                                </div> -->

                            </div>
                        </template>

                    </div>
                </div>
                <!-- <div style="width: 80%;height: 40px;line-height: 40px;text-align: center;border-radius: 5px;background-color: #409EFF;font-size: 20px;font-weight: 600;color: white;margin: 10px auto;"
                    @click="outLogin">
                    退出登录
                </div> -->
            </div>
        </div>
        <div v-if="!isCollect" style="width: calc(100% - 250px);display: flex;height: 100%;flex-direction: column;">
            <div style="display: flex;align-items: center;justify-content: space-between;width: 95%;margin: 15px auto 15px;"
                v-if="agentList.length > 0">
                <div style="height: 35px; padding: 3px 15px;display: flex;align-items: center;justify-content: center;
                    border-radius: 40px;background-color: #EBEEF5;">
                    <div class="title_icon">
                        <el-image style="width: 22px; height: 22px;vertical-align: middle;" :src="theItem.aaIcon"
                            fit="fill"></el-image>
                    </div>
                    <div style="font-size: 14px;font-weight: bold;margin-left: 5px;">{{theItem.aaScene == 2 ? theItem.aaModelDes :theItem.aaTitle }}</div>
                </div>
                <div style="display: flex;align-items: center;justify-content: center;"
                    v-if="theItem.aaScene == 2">
                    <div :style="{
                        backgroundColor: theTbsName == theItem.aaTitle ? 'white' : '#E4E7ED', color: theIndex == 5 ? '#409EFF' : 'black', border: theIndex == 5 ? '1px solid #409EFF' : '1px solid #DCDFE6', fontWeight: theIndex == 5 ? 'bold' : 'normal',
                    }" style="font-weight: bold;font-size: 14px;height: 30px;padding: 5px 15px;border-radius: 30px;text-align: center;line-height: 20px;color: white;"
                        @click="agentChange('', {aaTitle: theItem.aaTitle,aaAppId: theItem.aaAppIdOne})">
                        {{ theItem.aaTitle }}
                    </div>
                    <div :style="{
                        backgroundColor: theTbsName == theItem.aaTitleTwo? 'white' : '#E4E7ED', color: theIndex == 9 ? '#409EFF' : 'black', border: theIndex == 9 ? '1px solid #409EFF' : '1px solid #DCDFE6', fontWeight: theIndex == 9 ? 'bold' : 'normal',
                        marginLeft: '20px'
                    }" style="font-weight: bold;font-size: 14px;height: 30px;padding: 5px 15px;border-radius: 30px;text-align: center;line-height: 20px;color: white;"
                        @click="agentChange('', {aaTitle: theItem.aaTitleTwo,aaAppId: theItem.aaAppIdTwo})">
                        {{ theItem.aaTitleTwo }}
                    </div>
                </div>
            </div>
            <div :style="{ width: winWidth < 600 ? '100%' : '100%' }" style="height: calc(100% - 80px);">

                <div class="mainDiv mainDivHeight" style="width: 65%;margin: 0 auto;overflow-y: auto;" v-if="isAgent">
                    <agentChat :agentMsg="theItem" :query="queryInput" :key="theIndex" @getChatMsg="getUserChatInit" :uploadFiles="chatUpload"
                        v-if="theItem && theItem.aaType == 1 || theItem.aaType == 3" />
                    <agentAiChat :agentMsg="theItem" :query="queryInput" :key="theIndex"
                        v-if="theItem && theItem.aaType == 2" @getChatMsg="getUserChatInit" />

                </div>


                <!-- 输入框 -->
                <div class="inputDiv" v-if="aucStatus == 1">
                    <div
                        style="width: 65%;margin: 0 auto;display: flex;flex-direction: column;align-items: center;justify-content: center;background-color: white; border-radius: 15px;
                        border: 1px solid #DCDFE6;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                        <div v-if="uploadFiles && uploadFiles.length > 0" class="scroll-style-light"
                            style="width:97%;margin: 0px auto;overflow-x: auto;display: flex;align-items: center;justify-content: flex-start;">
                            <div class="file-list">
                                <!-- 遍历上传成功的文件数组 -->
                                <div class="file-item" v-for="(file, index) in uploadFiles" :key="index">
                                    <!-- 文件图标：根据文件类型显示对应图标 -->
                                    <div class="file-icon">
                                        <i class="el-icon-picture"></i>
                                    </div>
                                    <!-- 文件信息 -->
                                    <div class="file-info">
                                        <!-- 文件名 -->
                                        <div class="file-name">{{ file.name }}</div>
                                        <!-- 文件类型 + 大小 + 字数（可选） -->
                                        <div class="file-meta">
                                            {{ file.type === 'image' ? '图片' : '' }}
                                        </div>
                                    </div>
                                    <div class="file-delete-btn">
                                        <el-button type="text" icon="el-icon-close" round style="background: none;"  @click.stop="handleDeleteFile(file.id)"
                                            size="mini" title="删除文件">
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%;height: 55%;padding: 10px;display: flex;align-items: center;"
                            class="inputSubClass">
                            <div style="width:50px;height: 50px;line-height: 65px;text-align: center;margin-right: 10px;"
                                @click="handleUpload">
                                <i class="el-icon-folder-add" style="font-size: 35px;color: #409EFF;"></i>
                            </div>
                            <div style="width:calc(100% - 110px);">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" placeholder="请输入内容"
                                    :disabled="btnDisabled" clearable v-model="query"
                                    style="border: none;background-color: #EBEEF5;border-radius: 20px;">
                                </el-input>
                            </div>
                            <div>
                                <div class="iconStyle" style="display: flex;align-items: center;justify-content: center;border-radius: 100%;border: 1px solid #EBEEF5;
                 box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);" @click="inputSub">
                                    <div>
                                        <el-image style="width: 100%;height: 100%;vertical-align:top;"
                                            src="https://txcloud.aojuai.com/icon/ajtools/agent/fs_btn.png"
                                            fit="fill"></el-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 95%;overflow-x: auto;display: flex;align-items: center;justify-content: flex-start;margin: 5px auto 5px;padding-bottom: 5px;"
                            class="scroll-style-light">
                            <template v-for="(agentItem) in agentList" >
                                <div :key="agentItem.aaId"  @click="agentChange(agentItem)" :style="{
                                    border: theIndex == agentItem.aaId ? '2px solid #409EFF' : '1px solid #abadb3'
                                }"  style="display: flex;align-items: center;justify-content: center;margin: 2px 10px;border-radius: 10px;min-width: 160px;padding: 6px 15px;">
                                    <el-image style="width: 17px; height: 17px;vertical-align: middle;"
                                        :src="agentItem.aaIcon" fit="fill"></el-image>
                                    <span style="margin-left: 10px;">{{agentItem.aaScene == 2  ? agentItem.aaModelDes: agentItem.aaTitle }}</span>
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- <div
                        style="width: 100%;height: 50px;display: flex;align-items: center;flex-direction: row-reverse;padding-right: 20px;">
                      
                        <div class="iconStyle" style="display: flex;align-items: center;justify-content: center;border-radius: 100%;border: 1px solid #EBEEF5;
                 box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);" @click="abortStream"
                            v-if="isOpen">
                            <div class="iconStyle_icon">
                                <el-image src="https://txcloud.aojuai.com/icon/ajtools/tools/stop.png"
                                    style="width: 100%;height: 100%;vertical-align:top;"></el-image>
                            </div>
                        </div>
                        <div class="iconStyle" style="display: flex;align-items: center;justify-content: center;border-radius: 100%;border: 1px solid #EBEEF5;
                 box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);" @click="createNewChat">
                            <div>
                                <i class="el-icon-plus"></i>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div v-if="isCollect" style="width: calc(100% - 250px);display: flex;height: 100%;flex-direction: column;">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </div>
        <el-drawer :visible.sync="isDrawer" :with-header="false" direction="ltr" size="80%">
            <div style="width: 300px;height:100%;background-color:#F5F5F5;">
                <div style="width: 80%;background-color: white;height: 50px;border-radius: 10px;margin: 10px auto;
                box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);line-height: 50px;text-align: center;"
                    @click="createNewChat">
                    <i class="el-icon-plus" style="font-size: 20px;margin-right: 5px;"></i>
                    <span style="font-size: 15px;font-weight: 500;">新建对话</span>
                </div>
                <div style="height: 1px;width: 90%;margin: 10px auto;background-color: #E4E7ED;"></div>
                <div style="width: 100%;overflow: auto;height: calc(100% - 160px);">
                    <div style="margin: 10px;font-size: 15px;">历史对话:</div>
                    <div style="width: 100%;margin: 10px auto;">
                        <template v-for="(item, index) in DiaHisList">
                            <div :key="item.aucId" style="width: 90%;margin:10px auto;background-color: #DCDFE6;position: relative;border-radius: 5px;overflow: hidden;"
                                :style="{ border: tapIndex == index ? '2px solid #409EFF' : 'none' }"
                                @click="DiaHisClick(item, index)">
                                <div
                                    style="width: 88%;margin-left: 10px;margin-top: 5px; font-size: 12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                    {{ item.chatTitle }}</div>
                                <div
                                    style="padding: 0px 15px; margin: 5px 10px; font-size: 22px;color: #E6A23C;border: 1px solid #E6A23C;border-radius: 30px;text-align: center;">
                                    {{ item.aaTitle || '' }}</div>
                                <div
                                    style="width: 88%;margin-left: 10px;margin-top: 5px;font-size: 11px;color: #606266;">
                                    {{ item.createtime }}</div>
                                <div style="position: absolute;top: 10px;right: 10px;"
                                    @click="delDiaHisClick(item, indexedDB)">
                                    <i class="el-icon-delete-solid" style="font-size: 16px;"></i>
                                </div>
                            </div>
                        </template>

                    </div>
                </div>
                <div style="width: 80%;height: 50px;line-height: 50px;text-align: center;border-radius: 5px;background-color: #409EFF;font-size: 20px;font-weight: 600;color: white;margin: 10px auto;"
                    @click="outLogin">
                    退出登录
                </div>
            </div>
        </el-drawer>
        <div style="width: 100%;height: 100%;background-color: rgba(7, 6, 6,0.5);position: fixed;top: 0;display: flex;align-items: center;justify-content: center;"
            v-if="isLogin">
            <div class="login-container">
                <h2>Ai小助手</h2>
                <form @submit.prevent="handleSubmit">
                    <div class="form-group">
                        <label for="username">用户名</label>
                        <input type="text" id="username" v-model="auPhone" required />
                    </div>
                    <div class="form-group">
                        <label for="password">密码</label>
                        <input type="password" id="password" v-model="auPw" required />
                    </div>
                    <button type="submit">登录</button>
                </form>
            </div>
        </div>
        <uploadOnly ref="fileUploadRef" :llm-upload-api="llmUploadApi" :llm-headers="llmHeaders"
            v-bind:historyFiles="uploadFiles" v-on:update:historyFiles="val => uploadFiles = val"
            :accept-type="'image/*,.pdf'" :limit="5" @upload-success="handleUploadSuccess"
            @upload-error="handleUploadError">
            <template #upload-btn></template>
        </uploadOnly>
    </div>
</template>

<script>
import {
    webUserLogin, getAiUserChatList, deleteAiUserChatOne, getAiUserChatMsgListHistory, getAiKnowledgeFileUser, getAiUserChatOne, addAiUserChatMsg, deleteAiUserChat, addAiUserChatOne, getAiAppList
} from "../api/api";
import uploadOnly from '../components/myUpload/uploadOnly.vue'
import agentChat from "../components/agentChat/agentChat.vue";
import agentAiChat from "../components/agentChat/agentAiChat.vue";
import { mapState, mapMutations, mapActions } from 'vuex'
import MarkdownIt from 'markdown-it';
var FileSaver = require('file-saver');
const md = new MarkdownIt(); // 创建markdown-it实例
export default {

    name: '',
    components: {
        agentChat, agentAiChat, uploadOnly
    },
    data() {
        return {
            chatUpload:[],
            uploadFiles: [],
            llmUploadApi: '',
            llmHeaders: {},
            isCollect: false,
            home_btn: 1,
            userInfo: null,
            isAgent: false,
            queryInput: '',
            agentList: [],
            theIndex: 0,
            theItem: {},
            api_url: 'https://qianfan.baidubce.com',
            isDrawer: false,
            activeNames: [],
            aucStatus: 1,
            tapIndex: -1,
            DiaHisList: [],

            controller: null,
            isOpen: false,
            mergeArr: [],
            isMerge: false,
            ThinkIndex: 0,
            DmxIndex: 0,
            AnswerMsg: '',
            ThinkMsg: '',
            ArgChat: [],
            WxAiChatSession: [],
            theConversationId: '',
            btnDisabled: false,
            timeID: null,
            loadingNums: 0,
            loadingText: '',

            query: '',
            winWidth: '',
            isLogin: true,
            jqr2: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/jqr2.png',
            diaArr: [
                {
                    type: 4, //1.是答,2.是问
                    conter: '',
                    eg: []
                }
            ],
            AnswerIndex: 0,
            auPhone: '',
            auPw: '',
            userMsg: {
                auPhone: '',
                auPw: ''
            },

        }
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.winWidth = val
            });
        },
        theItem: {
            handler(newVal) {
                this.llmUploadApi = newVal.aaAppBaseUrl + '/files/upload';
                this.llmHeaders = {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${newVal.aaAppId || ''}`
                };
            },
            deep: true
        }
    },
    created() {
        document.title = '傲举Ai小助手';
        this.winWidth = window.innerWidth;
        if (localStorage.getItem('aojuAi_token')) {
            this.isLogin = false
            this.isAgent = true
            this.agentInit()
        } else {
            this.isLogin = true
        }
    },
    mounted() {
        // 监听键盘事件
        window.addEventListener('keydown', this.keyDown)
    },
    destroyed() {
        window.removeEventListener('keydown', this.keyDown, false)
    },
    activated() {
        if (localStorage.getItem('aojuAi_token')) {
            this.isLogin = false
            this.isAgent = true;
            this.isCollect = false;
            this.agentInit()
        } else {
            this.isLogin = true
        }

    },
    methods: {
        handleAgentChange() {
            // 1. 清空父组件的文件列表
            this.uploadFiles = []
            // this.chatUpload = []
            // 2. 重置上传组件内部状态
            this.$refs.fileUploadRef.resetUploadState()
            // 3. 提示用户
        },
        // 核心：删除指定文件（点击右上角删除按钮触发）
        handleDeleteFile(fileId) {
            this.$confirm('确定要删除该文件吗？', '删除提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 过滤掉要删除的文件
                this.uploadFiles = this.uploadFiles.filter(file => file.id !== fileId)
                this.$message.success('文件删除成功')
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        // 仅触发上传
        handleUpload() {
            this.$refs.fileUploadRef.triggerUpload()
        },

        // 仅接收成功数据
        handleUploadSuccess(files) {
            console.log('上传完成的文件数据：', files)
            this.uploadFiles = files
            // 返回的数据格式示例：
            // [
            //   {
            //     name: '测试.png',
            //     extension: 'png',
            //     mime_type: 'image/png',
            //     type: 'image',
            //     raw: File对象,
            //     url: 'https://腾讯云COS地址/xxx.png',
            //     llmUrl: 'https://大模型服务地址/xxx.png'
            //   }
            // ]
        },

        // 仅接收失败信息
        handleUploadError(error) {
            console.error('上传失败：', error)
        },
        gotoCollect(val) {
            if (val) {
                this.home_btn = val;
                this.isCollect = true;
                console.log('//', this.$router);
                this.$router.push({ name: 'collectList' });
            }
        },
        handleCommand(command) {
            if (command == "a") {
                this.outLogin()
            }
        },
        agentChange(item, id) {
            if (id) {
                this.theTbsName = id.aaTitle;
                const newItem = JSON.parse(JSON.stringify(this.theItem))
                newItem.aaAppId = id.aaAppId;
                this.theItem = newItem
                this.queryInput = null;
                return;
            }
            this.handleAgentChange()
            this.theIndex = item.aaId;
            // this.theItem = JSON.parse(JSON.stringify(item));
            const newItem = JSON.parse(JSON.stringify(item))
            newItem.aaAppIdOne = item.aaAppId
            this.theTbsName = item.aaTitle
            this.$set(this, 'theItem',newItem)
            this.queryInput = null;

        },
        outLogin(val) {
            this.$confirm('是否确认退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (val) {
                    this.home_btn = val
                }
                localStorage.removeItem('aojuAi_token')
                this.isLogin = true
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        openDrawer() {
            this.isDrawer = true;
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        DownFile(item) {
            this.openLoading()
            getAiKnowledgeFileUser({
                akwName: item.dataset_name,
                akfName: item.document_name
            }).then(res => {
                const suffix = item.document_name;
                FileSaver.saveAs(res.data.akfPath, suffix)
                this.loadings.close()
                // 下载成功
                this.$message({
                    showClose: true,
                    message: '下载成功',
                    type: 'success'
                });
            })

        },
        handleChange(val) {
            console.log(val);
        },
        // 创建新对话
        createNewChat(val) {
            if (val) {
                this.home_btn = val;
                this.isCollect = false;
            }
            // 是否确认开启新对话?
            this.$confirm('是否确认开启新对话, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handleAgentChange()
                const newItem = this.agentList.find(i => i.aaId == this.theIndex);
                this.theItem = JSON.parse(JSON.stringify(newItem));
                this.theTbsName = newItem.aaTitle;
                this.theItem.aaAppIdOne = newItem.aaAppId;
                this.tapIndex = -1;
                this.$message({
                    type: 'success',
                    message: '已开启新对话!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },
        DiaHisClick(item, index) {
            const theItem = this.agentList.find(i => i.aaId == item.aaId);
            this.handleAgentChange()
            if (item.aaId == this.theIndex) {
                this.theItem.aucId = item.aucId;
                this.theItem = JSON.parse(JSON.stringify(this.theItem));
                this.queryInput = null;
            } else {
                this.theItem = JSON.parse(JSON.stringify(theItem));
                this.theItem.aucId = item.aucId;
                 this.theTbsName = theItem.aaTitle;
                this.theItem.aaAppIdOne = theItem.aaAppId;
                this.theIndex = item.aaId;
                this.queryInput = null;
            };
            this.isCollect = false;
            this.home_btn = 0;
            this.tapIndex = index;

        },
        delDiaHisClick(item) {
            this.$confirm('是否删除该对话？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteAiUserChatOne({
                    aucId: item.aucId
                }).then(res => {
                    if (res.status == 200) {
                        getAiUserChatList().then(res => {
                            this.DiaHisList = res.data;
                            const currentIndex = this.DiaHisList.findIndex(d => d.aucId === item.aucId);
                            if (currentIndex === this.tapIndex) {
                                this.tapIndex = 0;
                                this.DiaHisClick(this.DiaHisList[0], 0)
                            }
                        })
                        this.$message({
                            showClose: true,
                            message: '删除成功',
                            type: 'success'
                        });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 问答
        queryClick(val) {
            const myMsg = {
                type: 2,
                conter: val
            }
            const load = {
                type: 3,
                conter: '我正在努力思考，请稍等',
                stop: false,
            }
            this.diaArr.push(myMsg)
            this.diaArr.push(load)
            this.getTime();
            this.AnswerIndex = 0;
            this.btnDisabled = true;
            this.DmxInit(val)
        },
        // 重新问答
        restConter(index) {
            const qury = this.diaArr[index - 1].conter;
            const yuamrId = this.diaArr[index].yuamrId;
            if (yuamrId) {
                deleteAiUserChat({
                    yuamrId: yuamrId
                }).then(res => {
                    if (res.status == 200) {
                        this.diaArr.splice(index - 1, 2)
                        const myMsg = {
                            type: 2,
                            conter: qury
                        }
                        const load = {
                            type: 3,
                            conter: '我正在努力思考，请稍等',
                            stop: false,
                        }
                        this.diaArr.push(myMsg)
                        this.diaArr.push(load)
                        this.getTime();
                        this.AnswerIndex = 0;
                        this.btnDisabled = true;
                        this.DmxInit(qury)
                    }
                })
            } else {
                this.diaArr.splice(index - 1, 2)
                const myMsg = {
                    type: 2,
                    conter: qury
                }
                const load = {
                    type: 3,
                    conter: '我正在努力思考，请稍等',
                    stop: false,
                }
                this.diaArr.push(myMsg)
                this.diaArr.push(load)
                this.getTime();
                this.AnswerIndex = 0;
                this.btnDisabled = true;
                this.DmxInit(qury)
            }
        },
        // 复制文本
        conterCopy(index) {
            const textToCopy = this.diaArr[index].conter; // 获取要复制的文本
            const plainText = this.convertHtmlToText(textToCopy); // 转换为纯文本
            if (navigator.clipboard) {
                this.copyTextToClipboardUsingClipboardAPI(plainText);
            } else {
                this.copyTextToClipboardLegacy(plainText); // 使用旧的execCommand方法（不推荐）
            }
        },
        copyTextToClipboardUsingClipboardAPI(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$message({
                    showClose: true,
                    message: '复制成功',
                    type: 'success'
                });
            }).catch(err => {
                console.error('复制失败:', err);
            });
        },
        copyTextToClipboardLegacy(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed'; // 防止滚动到顶部
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                this.$message({
                    showClose: true,
                    message: '复制成功',
                    type: 'success'
                });
            } catch (err) {
                console.error('复制失败:', err);
            } finally {
                document.body.removeChild(textArea);
            }
        },
        // 大模型初始化
        DmxInit(val) {
            this.ThinkIndex = 0;
            this.DmxIndex = 0;
            this.AnswerMsg = '';
            this.ThinkMsg = '';
            this.AnswerIndex = 0;
            this.btnDisabled = true;
            this.requestTask_api(val)

        },
        // 中断请求
        abortStream() {
            if (this.controller) {
                this.controller.abort();
                this.isOpen = false;
                this.btnDisabled = false;

                // this.isStop = false;
                this.controller = null
            }
        },
        // 调用大模型的api
        async requestTask_api(val) {
            var that = this
            const str = {
                app_id: that.WxAiChatSession.aaAppId,
                conversation_id: that.WxAiChatSession.conversationId,
                stream: true,
                query: val,
            }
            this.controller = new AbortController();
            const signal = this.controller.signal;
            try {
                // const response = await fetch(that.api_url +'/v2/app/conversation/runs', {
                const response = await fetch('https://assistant.aojuai.com/api/v2/app/conversation/runs', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                        // 'X-Appbuilder-Authorization': that.WxAiChatSession.appSecret,
                    },
                    body: JSON.stringify(str), // 对象转为 JSON 字符串
                    // credentials: 'include',
                    // mode: 'no-cors',
                    signal
                })
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const reader = response.body.getReader(); // 获取流式读取器
                const decoder = new TextDecoder(); // 解码二进制数据为文本

                // console.log(decoder);
                while (true) {
                    const { done, value } = await reader.read(); // 逐块读取
                    if (done) break; // 流结束
                    const chunk = decoder.decode(value); // 解码为文本
                    // console.log('Received chunk:', chunk);
                    if (that.isMerge) {
                        that.mergeArr.push(chunk);
                        const mergeStr = that.mergeArr.join('');
                        var lines2 = mergeStr.split('\n'); // 假设每个数据项占一行，且用换行符分隔  
                        var dataItems2 = lines2.filter(line => line.startsWith('data: '));
                        var jsonObjects2 = dataItems2.map(item => {
                            // 移除每行开头的 "data: "
                            var jsonString2 = item.substring(6);
                            try {
                                // 将JSON字符串转换为对象  
                                return JSON.parse(jsonString2);
                            } catch (e) {
                                console.error("解析JSON时出错：", e, item);
                                return null;
                            }
                            // 将JSON字符串转换为对象  
                        });
                        if (jsonObjects2.length > 0) {
                            console.log(jsonObjects2);
                            jsonObjects2.forEach((item, index) => {
                                if (item && !item.is_completion) {
                                    if (item.content[0].event_type == 'thought') {
                                        // console.log(item.content);
                                        that.ThinkIndex = that.ThinkIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        that.ThinkMsg = that.ThinkMsg + item.content[0].outputs.text;
                                        that.diaArr[that.diaArr.length - 1].think = that.ThinkMsg + item.content[0].outputs.text;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }
                                    if (item.content[0].event_type == 'chat_reasoning') {
                                        // console.log(item.content);
                                        that.ThinkIndex = that.ThinkIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        that.ThinkMsg = that.ThinkMsg + item.content[0].outputs.text;
                                        that.diaArr[that.diaArr.length - 1].think = that.ThinkMsg + item.content[0].outputs.text;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }
                                    if (item.content[0].event_type == 'ChatAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }
                                    if (item.content[0].event_type == 'RAGAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.query = '';
                                        if (item.content[0].outputs.references.length > 0) {
                                            const references_arr = [];
                                            item.content[0].outputs.references.forEach((itemValue, itemIndex) => {
                                                const str = {
                                                    index: itemValue.id,
                                                    content: itemValue.content,
                                                    dataset_name: itemValue.dataset_name,
                                                    document_name: itemValue.document_name,
                                                    document_id: itemValue.document_id,
                                                }
                                                references_arr.push(str)
                                            })
                                            that.diaArr[that.diaArr.length - 1].fileList = references_arr
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        }

                                        // that.autoScroll()
                                    }
                                    if (item.content[0].event_type == 'FollowUpQuery') {
                                        const FollowUpQuery = {
                                            text: item.content[0].outputs.json ? item.content[0].outputs.json.follow_up_querys[0] : ''
                                        }
                                        // console.log(FollowUpQuery);
                                        that.diaArr[that.diaArr.length - 1].FollowUpQuery.push(FollowUpQuery);
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        // that.autoScroll()
                                    }
                                    that.mergeArr = []
                                    that.isMerge = false;
                                } else if (item && item.is_completion) {
                                    reader.releaseLock();
                                    clearInterval(that.timeID)
                                    // that.AnswerIndex = 0;
                                    // that.ThinkIndex = 0;
                                    // that.ThinkMsg = '';
                                    // that.AnswerMsg = '';
                                    that.diaArr[that.diaArr.length - 1].stop = true;
                                    that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                    that.loadingText = '';
                                    that.isOpen = false;
                                    that.loadingNums = 0;
                                    that.query = '';
                                    that.btnDisabled = false;
                                    that.mergeArr = []
                                    that.isMerge = false;
                                    addAiUserChatMsg({
                                        conversationId: that.WxAiChatSession.conversationId,
                                        yuamrQuestion: that.diaArr[that.diaArr.length - 2].conter,
                                        yuamrAnswer: that.diaArr[that.diaArr.length - 1].conter,
                                        yuamrThink: that.diaArr[that.diaArr.length - 1].think ? that.diaArr[that.diaArr.length - 1].think : '',
                                    })
                                }
                            })

                        }
                    } else {
                        var lines = chunk.split('\n'); // 假设每个数据项占一行，且用换行符分隔  
                        var dataItems = lines.filter(line => line.startsWith('data: '));
                        if (that.DmxIndex == 2) {
                            console.log(decoder);
                            that.diaArr.splice(that.diaArr.length - 1, 1);
                            const AiMsg = {
                                type: 1,
                                HanderImg: "https://txcloud.aojuai.com/icon/aojv/icon/ai.png",
                                conter: that.AnswerMsg,
                                FollowUpQuery: [],
                                think: '',
                                stop: false,
                                IsCollapse: true,
                                IsFlieShow: false,

                            }
                            that.diaArr.push(AiMsg);
                            clearInterval(that.timeID)
                            that.isOpen = true;
                            that.loadingText = '.';
                            that.loadingNums = 0;
                            // that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                        }
                        try {
                            var jsonObjects = dataItems.map(item => {
                                // 移除每行开头的 "data: "
                                // console.log(item);  
                                var jsonString = item.substring(6);
                                // 将JSON字符串转换为对象  
                                return JSON.parse(jsonString);
                            });
                            // console.log(jsonObjects);
                            jsonObjects.forEach((item, index) => {
                                if (!item.is_completion) {
                                    // console.log(item.content[0].event_type );
                                    if (item.content[0].event_type == 'thought') {
                                        // console.log(item.content);
                                        that.ThinkIndex = that.ThinkIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        that.ThinkMsg = that.ThinkMsg + item.content[0].outputs.text;
                                        that.diaArr[that.diaArr.length - 1].think = that.ThinkMsg + item.content[0].outputs.text;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                        // that.autoScroll()
                                    }
                                    if (item.content[0].event_type == 'chat_reasoning') {
                                        // console.log(item.content);
                                        that.ThinkIndex = that.ThinkIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        that.ThinkMsg = that.ThinkMsg + item.content[0].outputs.text;
                                        that.diaArr[that.diaArr.length - 1].think = that.ThinkMsg + item.content[0].outputs.text;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }
                                    if (item.content[0].event_type == 'ChatAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                        // console.log(item.answer);

                                        // that.autoScroll()
                                    }
                                    if (item.content[0].event_type == 'RAGAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        // console.log(Last_text);
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }
                                    if (item.content[0].event_type == 'FollowUpQuery') {
                                        // that.setData({AnswerIndex : that.data.AnswerIndex+1})
                                        // console.log(item.answer);
                                        const FollowUpQuery = {
                                            text: item.content[0].outputs.json ? item.content[0].outputs.json.follow_up_querys[0] : ''
                                        }
                                        // console.log(FollowUpQuery);
                                        that.diaArr[that.diaArr.length - 1].FollowUpQuery.push(FollowUpQuery);
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        // that.autoScroll()
                                    }
                                } else if (item.is_completion) {
                                    reader.releaseLock();
                                    clearInterval(that.timeID)
                                    that.AnswerIndex = 0;
                                    that.ThinkIndex = 0;
                                    that.ThinkMsg = '';
                                    that.AnswerMsg = '';
                                    that.diaArr[that.diaArr.length - 1].stop = true;
                                    that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                    that.loadingText = '';
                                    that.isOpen = false;
                                    that.loadingNums = 0;
                                    that.query = '';
                                    that.btnDisabled = false;
                                    addAiUserChatMsg({
                                        conversationId: that.WxAiChatSession.conversationId,
                                        yuamrQuestion: that.diaArr[that.diaArr.length - 2].conter,
                                        yuamrAnswer: that.diaArr[that.diaArr.length - 1].conter,
                                        yuamrThink: that.diaArr[that.diaArr.length - 1].think ? that.diaArr[that.diaArr.length - 1].think : '',
                                    }).then(res => {
                                        getAiUserChatList().then(res => {
                                            that.DiaHisList = res.data;
                                            this.tapIndex = 0;
                                        })
                                    })
                                }
                            })
                        } catch (e) {
                            console.error("解析JSON时出错：", e, chunk);
                            clearInterval(that.timeID)
                            that.mergeArr.push(chunk)
                            that.loadingNums = 0;
                            that.loadingText = '';
                            that.isMerge = true;
                        }
                    }

                }
            } catch (error) {
                if (error.name === 'AbortError') {
                    console.log('请求已中断');
                } else {
                    console.error('请求出错:', error);
                }
            } finally {
                this.controller = null;
            }


        },

        // 将html转纯文本
        convertHtmlToText(inputText) {
            var returnText = "" + inputText;
            returnText = returnText.replace(/<\/div>/ig, '\r\n');
            returnText = returnText.replace(/<\/li>/ig, '\r\n');
            returnText = returnText.replace(/<li>/ig, ' * ');
            returnText = returnText.replace(/<\/ul>/ig, '\r\n');
            //-- remove BR tags and replace them with line break
            returnText = returnText.replace(/<br\s*[\/]?>/gi, "\r\n");

            //-- remove P and A tags but preserve what's inside of them
            returnText = returnText.replace(/<p.*?>/gi, "\r\n");
            returnText = returnText.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, " $2 ($1)");

            //-- remove all inside SCRIPT and STYLE tags
            returnText = returnText.replace(/<script.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/script>/gi, "");
            returnText = returnText.replace(/<style.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/style>/gi, "");
            //-- remove all else
            returnText = returnText.replace(/<(?:.|\s)*?>/g, "");

            //-- get rid of more than 2 multiple line breaks:
            returnText = returnText.replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, "\r\n\r\n");

            //-- get rid of more than 2 spaces:
            returnText = returnText.replace(/ +(?= )/g, '');

            //-- get rid of html-encoded characters:
            returnText = returnText.replace(/&nbsp;/gi, " ");
            returnText = returnText.replace(/&amp;/gi, "&");
            returnText = returnText.replace(/&quot;/gi, '"');
            returnText = returnText.replace(/&lt;/gi, '<');
            returnText = returnText.replace(/&gt;/gi, '>');

            return returnText;
        },
        // 收起or展开 思考
        collapseTap(index) {
            this.diaArr[index].IsCollapse = !this.diaArr[index].IsCollapse
            this.$set(this.diaArr, index, this.diaArr[index])
        },
        // 收起or展开 参考资料
        collapseFileTap(index) {
            this.diaArr[index].IsFlieShow = !this.diaArr[index].IsFlieShow
            this.$set(this.diaArr, index, this.diaArr[index])
        },
        // 初始化
        createInit() {
            if (this.agentList.length === 0) return;

            getAiUserChatOne({
                aaAppId: this.agentList[0].aiApp.aaAppId
            }).then(res => {
                this.WxAiChatSession = res.data
                if (res.data.aiUserChatMsgList && res.data.aiUserChatMsgList.length > 0) {
                    res.data.aiUserChatMsgList.forEach(element => {
                        if (element.yuamrQuestion) {
                            const query = {
                                conter: element.yuamrQuestion,
                                type: 2
                            }
                            this.diaArr.push(query)
                            this.theConversationId = res.data.conversationId
                            if (element.yuamrAnswer) {
                                const query = {
                                    conter: element.yuamrAnswer,
                                    think: element.yuamrThink ? element.yuamrThink : '',
                                    yuamrId: element.yuamrId ? element.yuamrId : '',
                                    type: 1,
                                    IsCollapse: true,
                                    IsFlieShow: false,
                                    stop: true,
                                }
                                this.diaArr.push(query)
                            }
                        }
                    });
                }
            })
            getAiUserChatList().then(res => {
                this.DiaHisList = res.data
            })
        },
        getUserChatInit() {
            getAiUserChatList().then(res => {
                this.DiaHisList = res.data
            })
        },
        // agent 初始化
        async agentInit() {
            this.userInfo = JSON.parse(localStorage.getItem('aojuAi_userInfo'))
            getAiAppList().then(res => {
                const data = JSON.parse(JSON.stringify(res.data));
                this.agentList = res.data
                this.theIndex = res.data.length > 0 ? res.data[0].aaId : 0
                this.theItem = res.data.length > 0 ? JSON.parse(JSON.stringify(data[0])) : '';
                this.theTbsName =  res.data.length > 0 ? res.data[0].aaTitle : 0;
                this.theItem.aaAppIdOne = res.data.length > 0 ? res.data[0].aaAppId : '',
                console.log(this.theItem);
                getAiUserChatList().then(res => {
                    this.DiaHisList = res.data
                })

            })

        },
        // 登录
        ...mapMutations(['changeuser']),
        handleSubmit() {
            if (this.auPhone == '' || this.auPw == '') {
                this.$message({
                    showClose: true,
                    message: '请输入账号和密码',
                    type: 'danger'
                });
                return
            }
            webUserLogin({
                auPhone: this.auPhone,
                auPw: this.auPw
            }).then(res => {
                if (res.status == 200) {
                    this.$message({
                        showClose: true,
                        message: '登录成功',
                        type: 'success'
                    });
                    if (this.changeuser) {
                        this.changeuser({ userMsg: res.data })
                    }
                    this.isLogin = false;
                    // this.agentInit()
                    window.location.reload();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'danger'
                    });
                }
            });
        },

        // 输入框提交事件
        inputSub() {
            console.log('11', this.query);

            if (this.query == '') {
                this.$message({
                    showClose: true,
                    message: '请输入内容',
                    type: 'danger'
                });
                return
            }
            this.queryInput = this.query;
            this.chatUpload = this.uploadFiles.length > 0 ? JSON.parse(JSON.stringify(this.uploadFiles)) : [];
            this.handleAgentChange()
            this.query = ''
        },
        keyDown(e) {
            //console.log(e)
            if (e.key == 'Enter') {
                this.inputSub();
                e.preventDefault()//去掉默认的换行
            }
        },
        getTime() {
            var that = this
            that.timeID = setInterval(() => {
                if (that.loadingNums >= 4) {
                    that.loadingNums = 0;
                    that.loadingText = '.'
                }
                that.loadingNums = that.loadingNums + 1
                that.loadingText = that.loadingText + '.'

            }, 400) //每隔1s调用一次timer函数
        },
    }
}
</script>

<style scoped>
.file-list {
    margin-top: 10px;
    display:flex;
    align-items: center;
}

/* 右上角删除按钮（核心样式） */
.file-delete-btn {
    position: absolute;
    top:3px;
    right: 0px;
}

.file-delete-btn .el-button {
    color: black;
    padding: 0;
    width: 16px;
    height: 16px;
    display: flex;
    font-size: 12px;
    align-items: center;
    justify-content: center;
}

.file-delete-btn .el-button:hover {
    background-color: #fee;
    border-radius: 50%;
}

.file-item {
    display: flex;
    align-items: center;
    padding: 8px 18px;
    background: #f8f9fa;
    border-radius: 4px;
    position: relative;
    margin:0 10px;
    /* 关键：给删除按钮定位 */
}

.file-icon {
    font-size: 24px;
    color: #409eff;
    margin-right: 12px;
}

.file-info {
    flex: 1;
}

.file-name {
    font-size: 14px;
    color: #333;
}

.file-meta {
    font-size: 12px;
    color: #999;
    margin-top: 2px;
}

.chat_history {
    transition: background-color 0.3s ease;
    /* 可选：鼠标移入显示手型，提升交互体验 */
    cursor: pointer;
    width: 95%;
    margin: 10px auto;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    padding: 0 5px;
}

.chat_history:hover {
    background: #e9eaec !important;
    /* 浅蓝背景，与图标颜色呼应，可自行修改 */
}

/* 样式1：浅色滚动条 */
.history_class::-webkit-scrollbar {
    height: 6px;
    width: 3px;
}

.history_class::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
}

.home_btn_active {
    color: #7757ff;
    font-weight: bold;
    background: #e5ebf7 !important;
    border: 1px solid #c2d4f8;
}

.new-chat-btn {
    width: 90%;
    padding: 0 10px;
    height: 40px;
    border-radius: 10px;
    margin: 10px auto;
    line-height: 40px;
    /* 默认背景色（可根据需求修改，这里用浅白色示例） */
    background-color: #f3f4f6;
    /* 可选：添加过渡效果，让背景色切换更平滑 */
    transition: background-color 0.3s ease;
    /* 可选：鼠标移入显示手型，提升交互体验 */
    cursor: pointer;
}

/* 2. 定义:hover悬浮样式，设置鼠标移入时的背景色 */
.new-chat-btn:hover {
    background-color: #e9eaec;
    /* 浅蓝背景，与图标颜色呼应，可自行修改 */
}

.inputSubClass ::v-deep .el-textarea__inner {
    background-color: #EBEEF5 !important;
}

/* 样式1：浅色滚动条 */
.scroll-style-light::-webkit-scrollbar {
    height: 4px;
}

.scroll-style-light::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;

}

div ::v-deep .el-collapse-item__content {
    padding-bottom: 0px !important;
}

.img_type1 {
    width: 100px;
    height: 100px;
    position: absolute;
    top: -40px;
    left: 10px;
}

.mainDivHeight {
    height: calc(100% - 100px) !important;
}

.mainDiv::-webkit-scrollbar {
    display: none;
}

.mainDivHeight::-webkit-scrollbar {
    display: none;
}

.egclass {
    position: relative;
    max-width: 90%;
    margin: 20px 10px 10px;
    padding: 35px 10px 10px;
    /* background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/dhk.png'); */
    /* background-repeat: no-repeat; */
    /* background-color: #D3DFFE; */
    /* background-size: cover; */
    font-size: 16px;
    border-radius: 30px 30px 30px 0;
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.message {
    position: relative;
    max-width: 98%;
    margin: 10px;
    padding: 10px;
    /* background-color: #D3DFFE; */
    /* background: linear-gradient(to bottom, #accdf1, white); */
    font-size: 22rpx;
    /* display: flex; */
    /* z-index: 10; */
}

.login-container {
    max-width: 400px;
    margin: 50px auto;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    font-family: 'Arial', sans-serif;

}

h2 {
    text-align: center;
    color: #333333;
    font-size: 24px;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    color: #555555;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #cccccc;
    border-radius: 5px;
    font-size: 16px;
    transition: border-color 0.3s, box-shadow 0.3s;
}

input:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25);
}

button {
    width: 100%;
    padding: 12px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
}

button:hover {
    background-color: #36956f;
}

.egTitleclass {
    font-size: 21px;
    font-weight: bold;
    position: absolute;
    top: 0px;
    left: 10px;
}

.inputDiv {
    width: calc(100% - 250px);
    min-height: 130px;
    position: fixed;
    bottom: 8px;
    left: 250px;


}

.inputDiv div ::v-deep .el-textarea__inner {
    border: none !important;
    resize: none !important;
}

.iconStyle {
    width: 40px;
    height: 40px;
    margin: 10px;
    font-size: 22px;
}

.iconStyle_icon {
    width: 20px;
    height: 20px;
}

.flex-right {
    flex-direction: row-reverse;
}

.flex-right>.message::after {
    left: unset;
    right: -5px;
}

.message2 {
    position: relative;
    max-width: 98%;
    margin: 10px;
    padding: 10px;
    background: linear-gradient(to right, #6299FE, #1159E6);
    border-radius: 10px 10px 0 10px;
    font-size: 16px;
    /* display: flex; */
    /* z-index: 10; */
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.aoju_title {
    width: 100%;
    font-size: 18px;
}

@media (max-width: 600px) {
    .aoju_title {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

    }

    .inputDiv {
        width: 95%;
        min-height: 80px;
        position: fixed;
        bottom: 10px;
        left: 2.5%;
        border-radius: 15px;
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .egTitleclass {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        top: 0px;
        left: 10px;
    }

    .mainDiv {
        width: 100% !important;
        height: calc(100% - 100px) !important;

    }

    .login-container {
        padding: 30px;
    }

    h2 {
        font-size: 20px;
    }

    input,
    button {
        font-size: 14px;
        padding: 10px;
    }

    .egclass {
        position: relative;
        max-width: 98% !important;
        margin: 20px 0px 0px;
        padding: 25px 10px 10px;
        /* background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/dhk.png'); */
        /* background-repeat: no-repeat; */
        /* background-color: #D3DFFE; */
        /* background-size: cover; */
        font-size: 12px;
        border-radius: 30px 30px 30px 0;
        /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
    }

    .message2 {
        position: relative;
        max-width: 98%;
        margin: 10px;
        padding: 10px;
        background: linear-gradient(to right, #6299FE, #1159E6);
        border-radius: 5px 5px 0 5px;
        font-size: 10px !important;
        /* display: flex; */
        /* z-index: 10; */
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    /* 确保没有不必要的外部边距或填充 */
    ol,
    ul,
    dl {
        padding-left: 20px !important;
        /* 移除默认的左填充 */
        margin: 0;
        /* 移除默认的外边距 */
    }

    .message {
        position: relative;
        max-width: 98%;
        margin: 10px;
        padding: 10px;
        /* padding-left: 15px !important; */
        /* background-color: #D3DFFE; */
        /* background: linear-gradient(to bottom, #accdf1, white); */
        /* border-radius: 30px 30px 30px 0; */
        font-size: 10px !important;
        /* display: flex; */
        /* z-index: 10; */
        overflow: auto;
        /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
    }

}
</style>
